import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import transportOnlyIcon from "@icons/ic-transport-only.svg";
import transportTreatmentIcon from "@icons/ic-transportTreatment.svg";
import treatmentOnlyIcon from "@icons/ic-treatment.svg";
import { renderPriceWithCurrency } from "@utils/utils";
import {
  GridRow,
  GrayDarkerSpan,
  GraySpan,
  PriceContainer,
} from "./Solutions.styled";

const Price = (props) => {
  const { t, solutionData } = props;
  let selectedTransportPrice = [];
  selectedTransportPrice = solutionData?.solutionTransportPrices?.filter(
    (price) => price.selectedPrice
  );

  return (
    <>
      {solutionData.priceType === 3 && (
        <PriceContainer>
          <Image
            src={transportOnlyIcon}
            alt={t("TRANSPORT_ONLY")}
            title={t("TRANSPORT_ONLY")}
            styles={{
              height: "25px",
              width: "25px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          />
          <GrayDarkerSpan>
            {selectedTransportPrice.length !== 0 &&
              renderPriceWithCurrency(
                selectedTransportPrice?.[0].price,
                t(selectedTransportPrice?.[0].unit),
                selectedTransportPrice?.[0].currency.symbol,
                selectedTransportPrice?.[0].currency.position
              )}
          </GrayDarkerSpan>
          <GraySpan>
            {selectedTransportPrice.length !== 0 &&
              " - " + selectedTransportPrice?.[0].transportType.name}
          </GraySpan>
        </PriceContainer>
      )}
      {solutionData.priceType === 4 && (
        <PriceContainer>
          <Image
            src={treatmentOnlyIcon}
            alt={t("TREATMENT_ONLY")}
            title={t("TREATMENT_ONLY")}
            styles={{
              height: "25px",
              width: "25px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          />
          <GrayDarkerSpan>
            {renderPriceWithCurrency(
              solutionData?.solutionTreatmentPrices?.[0].price,
              t(solutionData?.solutionTreatmentPrices?.[0].unit),
              solutionData?.solutionTreatmentPrices?.[0].currency.symbol,
              solutionData?.solutionTreatmentPrices?.[0].currency.position
            )}
          </GrayDarkerSpan>
        </PriceContainer>
      )}
      {solutionData.priceType === 1 && (
        <>
          <GridRow>
            <PriceContainer>
              <Image
                src={treatmentOnlyIcon}
                alt={t("TREATMENT_ONLY")}
                title={t("TREATMENT_ONLY")}
                styles={{
                  height: "25px",
                  width: "25px",
                  marginRight: "5px",
                  cursor: "pointer",
                }}
              />
              <GrayDarkerSpan>
                {renderPriceWithCurrency(
                  solutionData?.solutionTreatmentPrices?.[0].price,
                  t(solutionData?.solutionTreatmentPrices?.[0].unit),
                  solutionData?.solutionTreatmentPrices?.[0].currency.symbol,
                  solutionData?.solutionTreatmentPrices?.[0].currency.position
                )}
              </GrayDarkerSpan>
            </PriceContainer>
          </GridRow>
          <PriceContainer>
            <Image
              src={transportOnlyIcon}
              alt={t("TRANSPORT_ONLY")}
              title={t("TRANSPORT_ONLY")}
              styles={{
                height: "25px",
                width: "25px",
                marginRight: "5px",
                cursor: "pointer",
              }}
            />
            <GrayDarkerSpan>
              {solutionData.solutionStatus !== 5 &&
                selectedTransportPrice.length !== 0 &&
                renderPriceWithCurrency(
                  selectedTransportPrice?.[0].price,
                  t(selectedTransportPrice?.[0].unit),
                  selectedTransportPrice?.[0].currency.symbol,
                  selectedTransportPrice?.[0].currency.position
                )}
              {solutionData.solutionStatus === 5 && "?"}
            </GrayDarkerSpan>
            <GraySpan>
              {selectedTransportPrice.length !== 0 &&
                " - " + selectedTransportPrice?.[0].transportType.name}
            </GraySpan>
          </PriceContainer>
        </>
      )}
      {solutionData.priceType === 2 && (
        <PriceContainer>
          <Image
            src={transportTreatmentIcon}
            alt={t("TREATMENT_TRANSPORT_PRICE")}
            title={t("TREATMENT_TRANSPORT_PRICE")}
            styles={{
              height: "25px",
              width: "45px",
              marginRight: "5px",
              cursor: "pointer",
            }}
          />
          <GrayDarkerSpan>
            {solutionData.solutionStatus !== 5 &&
              selectedTransportPrice.length !== 0 &&
              renderPriceWithCurrency(
                selectedTransportPrice?.[0].price,
                t(selectedTransportPrice?.[0].unit),
                selectedTransportPrice?.[0].currency.symbol,
                selectedTransportPrice?.[0].currency.position
              )}
            {solutionData.solutionStatus === 5 && "?"}
          </GrayDarkerSpan>
          <GraySpan>
            {selectedTransportPrice.length !== 0 &&
              " - " + selectedTransportPrice?.[0].transportType.name}
          </GraySpan>
        </PriceContainer>
      )}
    </>
  );
};

Price.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Price);
